import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
import useLocaleRoute from "../../../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../../../store/StoreProvider";
import Selection from "../../../../../../../../common/components/input/Selection";
//
import Act from "../../../../../../../../store/actions";
import { MODULE_ID } from "../../../../../../../../config/CONSTANTS";
import urls from "../../../../../../../../api/project/ApiUrls";
// eslint-disable-next-line import/named
import { imageMineTypeOpts, FILE_MINE_TYPE_KEY } from "../option";
import {
  exportImageHandler,
  handleExportMeetCount,
  relationMatrixExport,
  downloadGephi,
} from "../utils/exportHelper";
import { IMG_SETTING } from "../../../../../../../../config/config.sna";
import { SNA_DISPLAY_DIV_ID } from "../../../../../../config";
import { bindingsToNodesLinks } from "../../../../displayArea/drawSnaLxt/drawNetwork/SNAutils";

const ExportProcess = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group } = user;
  const {
    fileMineType,
    imageResolution,
    imageMineType,
    startExportFile,
    startExportImage,
  } = sna.export || {};
  const { eventList } = sna.diaryInfo;
  const { snaRef, drawNetworkData } = sna.snaDisplay;
  // local state

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const onSuccess = (moreFunc) => () => {
    dispatch({
      type: Act.COMMON_SET_SUCCESS_MESSAGE,
      payload: {
        open: true,
        content: intl.formatMessage({
          id: "sna.topPanel.export.export.finish",
          defaultMessage: "檔案匯出完成",
        }),
      },
    });
    if (moreFunc && typeof moreFunc === "function") {
      moreFunc();
    }
  };

  const onError = (moreFunc) => (err) => {
    dispatch({
      type: Act.COMMON_SET_ERROR_MESSAGE,
      payload: {
        open: true,
        content: err.message,
      },
    });
    if (moreFunc && typeof moreFunc === "function") {
      moreFunc();
    }
  };

  const alertFunc = (msgStr) => {
    dispatch({
      type: Act.COMMON_SET_ERROR_MESSAGE,
      payload: {
        open: true,
        content: msgStr,
      },
    });
  };

  const handleExportFile = () => {
    const finallyFunc = () => {
      dispatch({
        type: Act.SNA_EXPORT_START_EXPORT_FILE,
        payload: false,
      });
    };
    if (fileMineType === FILE_MINE_TYPE_KEY.meetCount) {
      const tmpNetworkData = bindingsToNodesLinks(eventList || [], true);

      handleExportMeetCount(
        tmpNetworkData,
        alertFunc,
        onSuccess(finallyFunc),
        onError(finallyFunc)
      );
    } else if (fileMineType === FILE_MINE_TYPE_KEY.relationMatrix) {
      const tmpNetworkData = bindingsToNodesLinks(eventList || [], false);

      relationMatrixExport(
        tmpNetworkData,
        alertFunc,
        onSuccess(finallyFunc),
        onError(finallyFunc)
      );
    } else if (fileMineType === FILE_MINE_TYPE_KEY.gephi) {
      const copyTmp = JSON.parse(JSON.stringify(drawNetworkData));

      copyTmp.links = drawNetworkData?.links?.map((el) => ({
        ...el,
        weight: el.count,
      }));
      // download current graph as gephi
      downloadGephi(
        // drawNetworkData,
        copyTmp,
        alertFunc,
        onSuccess(finallyFunc),
        onError(finallyFunc)
      );
    }
  };

  useEffect(() => {
    if (startExportFile) {
      handleExportFile();
    }
  }, [startExportFile]);

  const handleExportImage = () => {
    const targetEle = document.getElementById(SNA_DISPLAY_DIV_ID);
    if (!targetEle) return;
    dispatch({
      type: Act.COMMON_SET_LOADER,
      payload: {
        open: true,
      },
    });
    // start export image
    exportImageHandler(targetEle, {
      resolution: imageResolution,
      mineType: IMG_SETTING?.[imageMineType]?.mineType || null,
      extension: IMG_SETTING?.[imageMineType]?.extension || null,
    })
      .then((res) => {
        onSuccess(null)();
      })
      .catch((err) => {
        onError(null)(err);
      })
      .finally(() => {
        dispatch({
          type: Act.COMMON_SET_LOADER,
          payload: {
            open: false,
          },
        });
        dispatch({
          type: Act.SNA_EXPORT_START_EXPORT_IMAGE,
          payload: false,
        });
      });
  };

  useEffect(() => {
    if (startExportImage) {
      handleExportImage();
    }
  }, [startExportImage]);

  return null;
};

export default ExportProcess;
